import React from 'react';
import { isNum, colorAt } from './chartUtils';
import './charts.css';

/** One horizontal stacked bar. segments: [{key,label,value,color?}]. The legend lists every value as text. */
const StackedBar = ({ segments, total, label, testId }) => {
  const segs = (segments || []).filter((s) => s && isNum(s.value) && s.value >= 0);
  const sum = isNum(total) ? total : segs.reduce((a, s) => a + s.value, 0);
  if (!segs.length || sum <= 0) return <div className="pl-barlist__empty" data-testid={testId}>No data to chart yet.</div>;
  let x = 0;
  const aria = `${label || 'Breakdown'}: ${segs.map((s) => `${s.label} ${s.value}`).join(', ')}${isNum(total) ? ` of ${total}` : ''}`;
  return (
    <div data-testid={testId}>
      <svg className="pl-chart" role="img" aria-label={aria} width="100%" height="16">
        <title>{aria}</title>
        <desc>Stacked bar; the legend below lists every value.</desc>
        <rect x="0" y="0" width="100%" height="16" rx="4" fill="var(--chart-track)" />
        {segs.map((s, i) => {
          const w = (s.value / sum) * 100;
          const node = w > 0 ? <rect key={s.key} x={`${x}%`} y="0" width={`${w}%`} height="16" fill={s.color || colorAt(i)} stroke="var(--color-bg-white)" strokeWidth="2" /> : null;
          x += w;
          return node;
        })}
      </svg>
      <ul className="pl-chart-legend">
        {segs.map((s, i) => (
          <li key={s.key}>
            <span className="pl-chart-swatch" style={{ background: s.color || colorAt(i) }} />
            {s.label} <span className="pl-chart-legend__n">{s.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StackedBar;
